export const CLASS_NAME = 'saved-view-component';
export const MOUSE_DOWN_EVENT_NAME = 'mousedown';

export const VIEW_TYPE = {
  CLEAN: 'clean',
  DASHBOARD: 'dashboard',
  DASHBOARD_MAP: 'dashboard-map',
  DASHBOARD_PROPERTY: 'dashboard-property',
  INSPECT: 'inspect',
  MAINTAIN: 'maintain',
  SCHEDULE: 'schedule',
};

export const BUTTON_TYPE = {
  DELETE: 'delete',
  RENAME: 'rename',
};

export const ADD_NEW_VIEW_BUTTON = { label: 'Add a new view', icon: 'plus' };
